module.exports = __webpack_public_path__ + "img/home_ic_discounts.0d4cc996.png";